module.exports = __webpack_public_path__ + "img/h5img42.498ecf1e.png";